import { SignedImage } from "./SignedImage";

interface TierImageProps {
    /** Bucket-root S3 key of the tier image (resolved to a signed URL). */
    imageUrl?: string;
    alt?: string;
    className?: string;
}

export function TierImage({ imageUrl, alt, className }: TierImageProps) {
    // No bundled fallback art — the tier image must come from the API so we never
    // show the wrong tenant/tier artwork; render nothing when it can't be shown.
    return (
        <SignedImage
            imageKey={imageUrl}
            alt={alt}
            className={className}
            sizeClassName="h-[130px] w-auto"
            skeletonClassName="rounded-[10px] w-[100px]"
            fallback={() => null}
        />
    );
}
